import React = require("react");
import {ProgressIndicator} from "@vebox/etui-core";

interface PercentageCircleProps {
    width: number;
    height: number;
    percentage: number;
    name: string;
    percentageColor: string;
    percentageColorOpacity?: number;
    arcWidth: number;
    anticlockwise?: boolean;
    valueText?: string;
}

/**
 * A circle with a percentage inside.
 */

export class PercentageCircle extends React.Component <PercentageCircleProps, {}> {

    public static DEFAULT_COLOR = "orange";

    constructor(props: PercentageCircleProps) {
        super(props);
    }

    public render() {
        /*const div = new ReactFauxDOM.Element("div");
        const {width, height, percentage} = this.props;
        const svg = d3.select(div)
            .append("svg")
            .attr("width", width)
            .attr("height", height);
        svg.append("g")
            .attr("transform", `translate(${width / 2},${height / 2})`);
        svg.append("g")
            .attr("transform", `translate(${width / 2},${(height / 2) + 2})`)
            .append("text")
            .style("textAnchor", "middle")
            .style("dominantBaseline", "middle")
            .append("tspan")
            .attr("x", "0")
            .attr("dy", "0")
            .text(this.props.valueText || ((percentage).toFixed(1) + "%"));
        this.addArc(svg, 360, "#efefef");
        this.addArc(svg, this.percToDeg(this.props.percentage), this.props.percentageColor);
        return div.toReact();*/

        return <ProgressIndicator
            value={this.props.percentage}
            radius={this.props.height / 2}
            styles={{
                indicator: {
                    border: `1px solid ${this.props.percentageColor}`,
                },
                root: {
                    m: "auto",
                }
            }}
            props={{
                circle: {
                    stroke: this.props.percentageColor,
                },
            }}
        />;
    }
}
